import React from "react";
import { RxSlash } from "react-icons/rx";
import { VscLibrary } from "react-icons/vsc";
import { useGetFolderQuery } from "./reduxworkbook/dataApiSlice";
import { useNavigate, useParams } from "react-router-dom";

export default function LibraryFolderPaths({ isFolderPresentInLibrary }) {
  const storedFolderId = sessionStorage.getItem("folderId"); // Default to "root"
  const { folderId: paramsFolderId } = useParams();
  console.log(paramsFolderId);
  const requiredFilterId = paramsFolderId || storedFolderId;
  console.log(requiredFilterId);

  const navigate = useNavigate();
  const {
    data: folderStructure,
    isSuccess,
    isLoading,
    isError,
    error,
  } = useGetFolderQuery("root"); // Fetch the entire folder structure from the root

  console.log("Folder Structure:", folderStructure);

  // Helper function to find the folder hierarchy leading to the current folder
  const findFolderHierarchy = (id, structure, path = []) => {
    if (!structure) return null; // Handle undefined structure gracefully

    for (const [currentId, folder] of Object.entries(structure)) {
      const newPath = [...path, { id: currentId, name: folder.folderName }];

      if (currentId === id) {
        // Found the target folder; return the full path
        return newPath;
      }

      // Recursively search subfolders
      const subPath = findFolderHierarchy(id, folder.subfolder, newPath);
      if (subPath) return subPath;
    }

    return null; // Return null if folder not found
  };

  // Generate the breadcrumb hierarchy only if the folder structure is loaded
  const breadcrumbHierarchy =
    requiredFilterId !== "root" && isSuccess
      ? findFolderHierarchy(requiredFilterId, folderStructure)
      : [];

  console.log("Breadcrumb Hierarchy:", breadcrumbHierarchy);

  return (
    <section className="w-full flex items-center justify-start">
      {/* <button onClick={() => navigate(-1)}>
      <IoArrowBackOutline />
    </button> */}
      <nav aria-label="Library breadcrumb" className="flex items-center">
        {/* Root Library */}
        <div
          className={`flex items-center gap-2 cursor-pointer ${
            requiredFilterId === "root"
              ? "text-gray-400"
              : "text-black font-[400] hover:underline"
          }`}
          onClick={() => {
            sessionStorage.removeItem("folderId");
            navigate("/home/dash/library/root"); // Navigate to the root folder
          }}
        >
          {!isFolderPresentInLibrary ||
          isFolderPresentInLibrary === undefined ? null : (
            <VscLibrary className="text-[0.9rem]" />
          )}
          Library
        </div>

        {/* Separator and Breadcrumb Items */}
        {breadcrumbHierarchy &&
          breadcrumbHierarchy.map((folder, index) => (
            <React.Fragment key={folder.id}>
              <div
                className={`cursor-pointer flex items-center justify-start gap-0 m-0 ${
                  folder.id === requiredFilterId
                    ? "text-gray-500"
                    : "text-black font-[400] hover:underline "
                }`}
                onClick={() => {
                  if (folder.id !== requiredFilterId) {
                    sessionStorage.setItem("folderId", folder.id);
                    navigate(`/home/dash/library/${folder.id}`); // Navigate to the folder
                  }
                }}
              >
                <RxSlash className="text-black m-0" />
                {folder.name}
              </div>
            </React.Fragment>
          ))}
      </nav>
    </section>
  );
}
